/**
 * @module IgniteScroll
 * @autor  Eugen Melnychenko
 */
angular.module("igScroll", []).directive("igScroll", ["$window", function (l) {
    return {
        restrict: "A", link: function (o, t, e) {
            var i, r = !1, n = o.$eval(e.igScroll), c = function () {
                i = parseInt(l.getComputedStyle(t[0], null).getPropertyValue("height").replace(/px/, "")) - l.innerHeight - (e.igScrollDist ? e.igScrollDist : 50)
            };
            (e.igScrollRoot ? document.querySelector(e.igScrollRoot) : l).onscroll = function () {
                i || c(), i < (this.pageYOffset || this.scrollTop) && (r || (r = !0, n ? n(function () {
                    r = !1, c()
                }) : null))
            }
        }
    }
}]);

angular.module("fx.infinite.scroll",[]).factory("fxScrollFactory",["$window",function(a){var b={offset:void 0,calculate:function(a,c){b.offset=parseInt(window.getComputedStyle(a[0],null).getPropertyValue("height").replace(/px/,""))-window.innerHeight-(c?c:50)},group:{current:"default",dependence:new Object},chain:new Object,append:function(a,c){b.chain[a]=!1,b.group.dependence[a]=c?c:"default"},renew:function(a){b.chain[a]&&(b.chain[a]=!1),b.offset=void 0},switch:function(a){b.group.current=a,b.offset=void 0}};return b}]).directive("fxScroll",["fxScrollFactory","$parse",function(a,b){return{restrict:"A",link:function(b,c,d){var f=d.fxScroll,g=d.fxScrollGroup,h=!!d.fxScrollReverse,i=!1,j=b.$eval(d.fxScrollFn);g=g?g:"default",a.append(f,g),angular.element(d.fxScrollRoot?document.querySelector(d.fxScrollRoot):window).bind("scroll",function(){a.offset||a.calculate(c,d.fxScrollDist),i=this.pageYOffset||this.scrollTop,(h?a.offset>i:a.offset<i)&&(a.chain[f]||a.group.current!==g||(a.chain[f]=!0,j&&j(function(){a.chain[f]=!1,a.calculate(c,d.fxScroll)})))})}}}]);

var ph, notify, modal, md, dropdown, dd;

!function(){"use strict";var a=angular.module("flex.bin.tab",[]);a.service("fx-tab",["$window",function(a){var b=this,c=location.hash.replace(/^(\#\/|\#)/i,""),d=new Object,e=new Object;b.add=function(a,b){"undefined"==typeof d[a]&&(d[a]=new Array),d[a].push(b)},b.toggle=function(a,b){var c;e[a]=b;for(var f=0;f<d[a].length;f++)c=document.querySelector('[fx-tab-fill="'+a+"."+d[a][f]+'"]'),"undefined"!=typeof c&&angular.element(c).hide();c=document.querySelector('[fx-tab-fill="'+a+"."+b+'"]'),"undefined"!=typeof c&&angular.element(c).show(),location.hash=b},angular.element(window).ready(function(){for(var a in d)if(d[a].indexOf(c)!==-1){var b=document.querySelector('[fx-tab="'+a+"."+c+'"]');angular.element(b).click()}else{var b=document.querySelector('[fx-tab="'+a+"."+d[a][0]+'"]');angular.element(b).click()}})}]),a.directive("fxTab",["fx-tab",function(a){return{restrict:"A",link:function(b,c,d){var e,f;d.fxTab&&/^(.*?)\.(.*?)$/i.test(d.fxTab)===!0&&([e,f]=d.fxTab.split("."),a.add(e,f),c.bind("click",function(){a.toggle(e,f)}))}}}])}();

angular.module('graph', ['igScroll', 'flex.bin', 'flex.bin.tab', 'flex.bin.file64', 'fx.infinite.scroll', 'ngCookies', 'luegg.directives', 'ivh.treeview', 'ngFlatDatepicker', 'readableTime','ui.mask', 'angularInlineEdit', 'ngSanitize', 'ngMessages', 'nsPopover', 'nvd3']);

$(function () {
    var $window = window, $document = document, $timeout = setTimeout;

    new (function () {   // graph ph implementation
        ph = this;

        var bunch = this['bunch'] = new (function () {
            this.form = {};

            this.pull = function ($branch, $name) {
                return bunch[$branch][$name];
            };

            this.push = function ($branch, $name, $essence) {
                bunch[$branch][$name] = $essence;
                return bunch;
            };
        });

        new (function () { // form implementation
            var reset = function (f) {
                f.find('span[ph-error]').text('');
            };

            var send = function (f, d) {
                var buffer, u = f.attr('action');
                u = u !== undefined && u.length > 0 ? u : $window.location.href;

                $.post(u, d).done(function (response) {
                    reset(f);

                    if (response['state'] === 'redirect') {
                        $window.location.replace(response['data']);
                    } else if (response['state'] === 'error') {
                        $.each(response['data'], function (k, v) {
                            buffer = f.find('span[ph-error="' + k + '"]');

                            if (buffer.length > 0) {
                                buffer.show();
                                buffer.text(v);
                            }
                        });
                    }
                });
            };

            var guard = function (e) {
                e.preventDefault();
                var f = $(this);

                // preguard

                send(f, f.serialize());
            };

            $('form').each(function () {
                var $instance = $(this), $identity = $instance.attr('ph-form');

                if ($identity !== undefined && $identity.length > 0) {
                    $instance.unbind(guard);
                    $instance.bind('submit', guard);
                }
            });
        })();
    })();

    notify = new (function () {
        this.make = function (html) {
            var html = $('<div class="notify" style="display:none">' + html + '</div>');

            $('div.notifier').append(html);
            html.fadeIn(150);

            $timeout(function () {
                html.fadeOut(500);

                $timeout(function () {
                    html.remove();
                }, 500);
            }, 5000);
        };
    })();

    md = modal = new (function () {
        $('[ph-md-trg]').bind('click', function (e) {
            e.preventDefault();
        });

        this.width = function (bunch, width) {
            $('[ph-md="' + bunch + '"]').find('.md-doc').css('max-width', width);

            return modal;
        };

        this.load = function (bunch, html) {
            $('[ph-md="' + bunch + '"]').html(html);

            return modal;
        };

        this.url = function (bunch, url, pre, post) {
            var shared = $('[ph-md="' + bunch + '"]');

            if (typeof pre !== undefined) pre(shared);

            $.get(url, function (data) {
                shared.find('.md-doc').html(data);

                if (typeof post !== undefined) post(shared);

                return modal;
            });
        };

        this.open = function (bunch) {
            $('[ph-md="' + bunch + '"]').show();

            return modal;
        };

        this.hide = function (bunch) {
            $('[ph-md="' + bunch + '"]').hide();

            return modal;
        };

        $(window).bind('mousedown', function (event) {
            $('[ph-md]').each(function (i, e) {
                if (event.target === e) {
                    $(e).hide();
                }
            })
        })
    });

    bld = new (function () {
        var _lbld, _lbld_btn, _lbld_tmp, _ld_screen = $('[ld-screen]');

        this.open = function (bunch, lock_screen) {
            _lbld_btn = $('[bld-btn="' + bunch + '"]')
            _lbld = $('[bld="' + bunch + '"]');
            _lbld_tmp = $('[bld-tmp="' + bunch + '"]');

            _lbld_btn.prop('disabled', true);
            _lbld.css('display', 'inline-block');
            _lbld_tmp.hide();

            if (lock_screen === true) {
                _ld_screen.show();
            }
        };

        this.hide = function (bunch) {
            _lbld_btn.prop('disabled', false);
            _ld_screen.hide();
            _lbld.hide();
            _lbld_tmp.show();
        };
    });

    // prevent = function(action) {

    // }

    dd = dropdown = new (function () {
        $('[ph-dd-trg]').bind('click', function (e) {
            e.preventDefault();
            var trg = $(this);
            trg.toggleClass('active');

            $('[ph-dd="' + trg.attr('ph-dd-trg') + '"]').toggleClass('open');
        });

        $(window).bind('mousedown', function (event) {
            var target = $(event.target);

            $('[ph-dd].open').each(function (i, e) {
                var ppdd = $(e);
                var ppddtrg = $('[ph-dd-trg="' + ppdd.attr('ph-dd') + '"]');
                var ppddpar = target.parents('[ph-dd]');
                var ppddtrgpar = target.parents('[ph-dd-trg]');

                if (target[0] != ppdd[0] && ppdd[0] !== ppddpar[0] && target[0] !== ppddtrg[0] && ppddtrg[0] !== ppddtrgpar[0]) {
                    $timeout(function () {
                        ppddtrg.removeClass('active');
                        ppdd.removeClass('open');
                    }, 20);
                }
            })
        })
    });

    tb = tab = new (function () {
        $('[ph-tab-trg]').bind('click', function (e) {
            $('[ph-tab-trg]').removeClass('active');
            $('[ph-tab]').removeClass('open');

            // e.preventDefault();
            var trg = $(this);
            trg.toggleClass('active');

            $('[ph-tab="' + trg.attr('ph-tab-trg') + '"]').toggleClass('open');
        });
    });
});

angular.module("readableTime", []).filter("readableTime", function () {
    return function (a) {
        var b, c, d, e, f, g, h;
        switch (a = parseInt(a, 10), e = 60, d = 60 * e, b = 24 * d, g = 7 * b, h = 365 * b, f = h / 12, c = function (a, b) {
            return b = 1 === a ? b : "" + b + "s", "" + a + " " + b
        }, !1) {
            case!(e > a):
                return c(a, "second");
            case!(d > a):
                return c(Math.floor(a / e), "minute");
            case!(b > a):
                return c(Math.floor(a / d), "hour");
            case!(g > a):
                return c(Math.floor(a / b), "day");
            case!(f > a):
                return c(Math.floor(a / g), "week");
            case!(h > a):
                return c(Math.floor(a / f), "month");
            default:
                return c(Math.floor(a / h), "year")
        }
    }
});
